import { FaUserClock } from "react-icons/fa";

export default FaUserClock;